import Vue from 'vue'
import axios from './axios'
import router from '../../router'
import store from '..'
import _ from 'lodash'
import qs from 'qs'

const messages = {
  errors: [],
  warnings: [],
  success: []
}

axios.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return qs.stringify(params)
  }

  config.params = {
    config: {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    ...config.params
  }

  return config
}, err => {
  return Promise.reject(err)
})

axios.interceptors.response.use(function(response) {
  let content_type = response.headers['content-type']


  if(content_type === 'application/pdf'){
    console.log('INTERCEPTOR::::', content_type )

  }

  if (response.status === 401)
  {
    console.log("woop 401")
    router.push('/login')
    return false
  }

  if (response.status === 403)
    return notify("Woop woop: 403" + response.url)

  notifyMessages(response.data.messages)
  if (response.data.status !== 'success')
    return Promise.reject(response)

  return {
    ...response.data,
    headers: response.headers
  }
}, function (error) {
  console.log(error.response.status)
  if (error.response.status === 401)
  {
    router.push('/login')
    // return
  }

  return Promise.reject(error)
})

const notifyMessages = (items) => {
  messages['errors'] = _.map(items.errors, "message")
  messages['warnings'] = _.map(items.warnings, "message")
  messages['success'] = _.map(items.success, "message")

  notify()
}

const notify = () => {
  showMessages(messages['errors'], 'error')
  showMessages(messages['warnings'], 'warnings')
  showMessages(messages['success'], 'success')

  messages['errors'].shift()
  messages['warnings'].shift()
  messages['success'].shift()
}

const showMessages = (messages, type) => {
  const message = messages.join("<br><br>")
  if (!message)
    return

  Vue.notify({
    text: message,
    type: type
  })
}


// axios.defaults.headers['content-type'] = 'application/x-www-form-urlencoded'

export default axios



// WEBPACK FOOTER //
// ./src/store/vue-axios/index.js